import client from "../client";

export const listOrgUsers = async (orgId) => {
  const res = await client.get(`/users/allOrgUsers?orgId=${orgId}`);
  return res.data;
};

export const createOrgUser = async (payload) => {
  const res = await client.post("/users/create", payload);
  return res.data;
};

export const updateOrgUser = async (userId, data) => {
  const res = await client.patch(`/users/${userId}`, data);
  return res.data;
};

export const deleteOrgUser = async (userId) => {
  const res = await client.delete(`/users/${userId}`);
  return res.data;
};
